import {Model} from "@tailflow/laravel-orion/lib/model";

export default class Enquiry extends Model<{}> {
    public $resource(): string {
        return "enquiries";
    }

    public $getKeyName() : string {
        return 'id';
    }
}